<template>
  <a
    class="rs-searchresults__vue__card"
    :href="fetchedItem.permalink"
    :lang="fetchedItem.lang"
    :dir="fetchedItem.lang_dir"
  >
    <div class="rs-searchresults__vue__card__left">
      <figure>
        <img
          v-if="
            fetchedItem.post_thumbnail_src &&
            fetchedItem.post_thumbnail_src.length >= 4
          "
          :src="fetchedItem.post_thumbnail_src[0]"
          :width="fetchedItem.post_thumbnail_src[1]"
          :height="fetchedItem.post_thumbnail_src[2]"
          :srcset="fetchedItem.post_thumbnail_srcset"
          sizes="200px"
          :alt="fetchedItem.post_thumbnail_alt"
        />

        <svg
          v-if="fetchedItem.post_type === 'rs_video'"
          class="rs-searchresults__vue__card__playicon"
          width="48"
          height="48"
          viewBox="0 0 68 47.812"
        >
          <g transform="translate(-6724 -9005)">
            <path
              id="outer"
              d="M81.512,71.481A8.544,8.544,0,0,0,75.5,65.43C70.2,64,48.933,64,48.933,64s-21.264,0-26.567,1.43a8.544,8.544,0,0,0-6.012,6.051c-1.421,5.337-1.421,16.473-1.421,16.473s0,11.136,1.421,16.474a8.417,8.417,0,0,0,6.012,5.954c5.3,1.43,26.567,1.43,26.567,1.43s21.264,0,26.567-1.43a8.417,8.417,0,0,0,6.012-5.954c1.421-5.337,1.421-16.474,1.421-16.474S82.933,76.818,81.512,71.481ZM41.978,98.065V77.844L59.751,87.955,41.978,98.065Z"
              transform="translate(6709.067 8941)"
              fill="red"
            />
            <path
              id="inner"
              d="M41.978,98.065V77.844L59.751,87.955,41.978,98.065Z"
              transform="translate(6709.067 8941)"
              fill="#fff"
            />
          </g>
        </svg>

        <div
          v-if="fetchedItem.post_type === 'rs_ccfe'"
          class="rs-searchresults__vue__card__ccfestamp"
        >
          <img
            width="92"
            src="/app/themes/rabbisacks2021/dist/images/covenant-conversation-family-edition-logo-dec2022.png"
            alt="Covenant &amp; Conversation Family Edition"
          />
        </div>

        <div
          v-if="fetchedItem.post_type === 'rs_chaggim'"
          class="rs-searchresults__vue__card__ccfestamp"
        >
          <img
            width="92"
            src="/app/themes/rabbisacks2021/dist/images/ceremony-celebration-family-edition-logo-dec2022.png"
            alt="Ceremony &amp; Celebration Family Edition"
          />
        </div>
      </figure>
    </div>

    <div class="rs-searchresults__vue__card__right">
      <div v-if="fetchedItem.tags && fetchedItem.tags.length" class="rs-searchresults__vue__card__tags">
        <span v-for="(taggroup, i) in fetchedItem.tags" :key="i">
          <span v-for="(tag, j) in taggroup" :key="j">
            <a :href="tag.permalink" v-html="tag.name" />
            <span v-if="j < taggroup.length - 1">, </span>
          </span>
          <span v-if="i < fetchedItem.tags.length - 1"> • </span>
        </span>
      </div>

      <h2
        v-html="fetchedItem.post_title"
        class="rs-searchresults__vue__card__title"
      ></h2>

      <!-- <div
      v-if="computedPermalink"
      v-html="computedPermalink"
      class="rs-searchresults__vue__card__link"
    /> -->

      <div
        v-if="fetchedItem.post_excerpt"
        v-html="fetchedItem.post_excerpt"
        class="rs-searchresults__vue__card__excerpt"
      />

      <div
        v-if="fetchedItem.post_date"
        v-html="fetchedItem.post_date"
        class="rs-searchresults__vue__card__date"
      />

      <!-- <div class="rs-searchresults__vue__card__meta">
        <div
          v-if="computedSection"
          class="rs-searchresults__vue__card__meta__item"
        >
          <div class="rs-searchresults__vue__card__meta__item__title">
            Section
          </div>
          <div
            v-html="computedSection"
            class="rs-searchresults__vue__card__meta__item__value"
          ></div>
        </div>

        <div
          v-if="computedFormats"
          class="rs-searchresults__vue__card__meta__item"
        >
          <div class="rs-searchresults__vue__card__meta__item__title">
            Format
          </div>
          <div
            v-html="computedFormats"
            class="rs-searchresults__vue__card__meta__item__value"
          ></div>
        </div>

        <div
          v-if="computedDate"
          class="rs-searchresults__vue__card__meta__item"
        >
          <div class="rs-searchresults__vue__card__meta__item__title">
            Published
          </div>
          <div
            v-html="computedDate"
            class="rs-searchresults__vue__card__meta__item__value"
            dir="ltr"
          ></div>
        </div>
      </div> -->
    </div>
  </a>
</template>

<script>
export default {
  props: {
    fetchedItem: Object,
  },
  computed: {
    // computedPermalink() {
    //   let response = "";
    //   // special case: if post type is rs_tribute, the link we want is the custom field: tribute_source_url
    //   if (
    //     this.fetchedItem.post_type &&
    //     this.fetchedItem.post_type === "rs_tribute" &&
    //     this.fetchedItem.tribute_source_url
    //   ) {
    //     try {
    //       response = decodeURI(this.fetchedItem.tribute_source_url);
    //     } catch (error) {
    //       console.log(error);
    //     }
    //     return response;
    //   }
    //   try {
    //     response = decodeURI(this.fetchedItem.permalink);
    //   } catch (error) {
    //     console.log(error);
    //   }
    //   return response;
    // },
    // computedSection() {
    //   let response = "";
    //   if (this.fetchedItem.post_type) {
    //     switch (this.fetchedItem.post_type) {
    //       case "post":
    //         response = "News";
    //         break;
    //       case "page":
    //         if (this.fetchedItem.post_name === "life-of-rabbi-jonathan-sacks") {
    //           response = "Life &amp; Impact";
    //         } else if (this.fetchedItem.post_name === "torah-teachings") {
    //           response = "Torah Teachings";
    //         } else if (this.fetchedItem.post_name === "covenant-conversation") {
    //           response = "Torah Teachings";
    //         } else if (this.fetchedItem.post_name === "jewish-festivals") {
    //           response = "Torah Teachings";
    //         } else if (this.fetchedItem.post_name === "jewish-thought") {
    //           response = "Torah Teachings";
    //         } else if (this.fetchedItem.post_name === "morality-and-ethics") {
    //           response = "Morality &amp; Ethics";
    //         } else if (this.fetchedItem.post_name === "articles") {
    //           response = "Morality &amp; Ethics";
    //         } else if (this.fetchedItem.post_name === "broadcasts") {
    //           response = "Morality &amp; Ethics";
    //         } else if (this.fetchedItem.post_name === "speeches") {
    //           response = "Morality &amp; Ethics";
    //         } else if (this.fetchedItem.post_name === "podcasts") {
    //           response = "Morality &amp; Ethics";
    //         } else if (this.fetchedItem.post_name === "conversations") {
    //           response = "Morality &amp; Ethics";
    //         } else if (this.fetchedItem.post_name === "books") {
    //           response = "Books";
    //         } else if (this.fetchedItem.post_name === "videos") {
    //           response = "Videos";
    //         } else if (this.fetchedItem.post_name === "educational-resources") {
    //           response = "Educational Resources";
    //         } else if (this.fetchedItem.post_name === "curriculum-resources") {
    //           response = "Educational Resources";
    //         } else if (this.fetchedItem.post_name === "teaching-resources") {
    //           response = "Educational Resources";
    //         } else if (this.fetchedItem.post_name === "quotes") {
    //           response = "Educational Resources";
    //         } else if (this.fetchedItem.post_name === "animations") {
    //           response = "Educational Resources";
    //         } else if (this.fetchedItem.post_name === "book-indexes") {
    //           response = "Educational Resources";
    //         } else if (
    //           this.fetchedItem.post_name ===
    //           "covenant-conversation-family-edition"
    //         ) {
    //           response = "Educational Resources";
    //         } else if (
    //           this.fetchedItem.post_name ===
    //           "ceremony-celebration-family-edition"
    //         ) {
    //           response = "Educational Resources";
    //         } else if (this.fetchedItem.post_name === "news") {
    //           response = "News";
    //         } else if (this.fetchedItem.post_name === "about-us") {
    //           response = "About Us";
    //         } else if (this.fetchedItem.post_name === "support-us") {
    //           response = "About Us";
    //         } else if (this.fetchedItem.post_name === "contact-us") {
    //           response = "About Us";
    //         } else if (this.fetchedItem.post_name === "whatsapp") {
    //           response = "About Us";
    //         } else if (this.fetchedItem.post_name === "subscribe") {
    //           response = "About Us";
    //         } else if (this.fetchedItem.post_name === "terms-of-use") {
    //           response = "About Us";
    //         } else if (this.fetchedItem.post_name === "privacy-policy") {
    //           response = "About Us";
    //         } else if (this.fetchedItem.post_name === "cookie-policy") {
    //           response = "About Us";
    //         } else {
    //           response = "Home";
    //         }
    //         break;
    //       case "rs_format":
    //         response = "Formats";
    //         break;
    //       case "category":
    //         response = "Categories";
    //         break;
    //       case "rs_cc":
    //       case "rs_cc_parsha":
    //       case "rs_cc_series":
    //         response = "Covenant &amp; Conversation";
    //         break;
    //       case "rs_ccfe":
    //         response = "Covenant &amp; Conversation Family Edition";
    //         break;
    //       case "rs_chaggim":
    //         response = "Ceremony &amp; Celebration Family Edition";
    //         break;
    //       case "rs_book":
    //       case "rs_book_format":
    //       case "rs_book_language":
    //         response = "Books";
    //         break;
    //       case "rs_bookindex":
    //         response = "Book Indexes";
    //         break;
    //       case "rs_tribute":
    //       case "rs_tribute_category":
    //         response = "Tributes";
    //         break;
    //       case "rs_quote":
    //         response = "Quotes";
    //         break;
    //       case "rs_video":
    //       case "rs_videoseries":
    //         response = "Videos";
    //         break;
    //       case "rs_life":
    //         response = "Life &amp; Impact";
    //         break;
    //       case "rs_curriculum":
    //         response = "Curriculum Resources";
    //         break;
    //       case "rs_lessonplan":
    //         response = "Teaching Resources";
    //         break;
    //       case "rs_festival":
    //         response = "Jewish Festivals";
    //         break;
    //       case "rs_moralvoice":
    //         response = "Morality &amp; Ethics";
    //         break;
    //       case "rs_jewishthought":
    //         response = "Jewish Thought";
    //         break;
    //       case "rs_archive":
    //         if (this.fetchedItem.post_terms) {
    //           if (this.fetchedItem.post_terms.rs_moralvoice) {
    //             response = "Morality &amp; Ethics";
    //             break;
    //           } else if (this.fetchedItem.post_terms.rs_jewishthought) {
    //             response = "Jewish Thought";
    //             break;
    //           }
    //         }
    //         response = "Archive";
    //         break;
    //       default:
    //         response = "";
    //     }
    //   }
    //   return response;
    // },
    // computedFormats() {
    //   let response = "";
    //   if (
    //     this.fetchedItem.post_terms &&
    //     this.fetchedItem.post_terms.rs_format
    //   ) {
    //     this.fetchedItem.post_terms.rs_format.forEach((element) => {
    //       if (response.length) response += ", ";
    //       response += element.name;
    //     });
    //   }
    //   return response;
    // },
    // computedDate() {
    //   let response = "";
    //   if (this.fetchedItem.post_date && this.fetchedItem.post_type) {
    //     switch (this.fetchedItem.post_type) {
    //       case "post":
    //       case "rs_archive":
    //       case "rs_cc":
    //       case "rs_ccfe":
    //       case "rs_chaggim":
    //       case "rs_book":
    //       case "rs_bookindex":
    //       case "rs_tribute":
    //       case "rs_video":
    //       case "rs_curriculum":
    //       case "rs_lessonplan":
    //         response = this.fetchedItem.post_date;
    //         break;
    //       case "page":
    //       case "rs_quote":
    //       case "rs_life":
    //       default:
    //         response = ""; // these types have no meaningful dates to be displayed
    //     }
    //   }
    //   return response;
    // },
    // computedTarget() {
    //   let response = "_blank";
    //   let permalinkHostname = "";
    //   if (this.fetchedItem.permalink) {
    //     let _url = new URL(this.fetchedItem.permalink);
    //     if (_url) {
    //       permalinkHostname = _url.hostname;
    //     }
    //   }
    //   if (permalinkHostname === new URL(window.location).hostname) {
    //     response = "_self";
    //   }
    //   return response;
    // },
  },
};
</script>
